import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class FinancialAccountTfsaType extends Enum {
  static SUCCESSOR_HOLDER = {
    key: 'successor_holder',
    get value() {
      return Lang.t('financialaccount.successor-holder');
    },
    get lowercaseValue() {
      return Lang.t('financialaccount.afe6280a-2d37-417e-9d50-60a094fcd642');
    }
  };

  static NAMED_BENEFICIARIES = {
    key: 'named_beneficiaries',
    get value() {
      return Lang.t('financialaccount.named-beneficiaries');
    },
    get lowercaseValue() {
      return Lang.t('financialaccount.8fd4b0b0-172a-4728-9b49-6730630ddf96');
    }
  };

  static NONE = {
    key: 'none',
    get value() {
      return Lang.t('financialaccount.none');
    },
    get lowercaseValue() {
      return Lang.t('financialaccount.1049ff99-bd57-4385-ad1d-e476aa8e098f');
    }
  };

  /**
   * @param {Estate} estate
   * @returns {Enum}
   */
  static showOptionsForEstate(estate) {
    return estate.contact.hasPartner
      ? FinancialAccountTfsaType.getValues()
      : [FinancialAccountTfsaType.NAMED_BENEFICIARIES, FinancialAccountTfsaType.NONE];
  }
}
